module.exports = __webpack_public_path__ + "static/media/financeHead.484096d8.jpg";